/**
 * Thin wrapper around `window.location`.
 *
 * Why the indirection? jsdom (from jsdom 26 / Jest 30 on) backs `window.location`
 * with a non-configurable `Location` instance: it can't be deleted, redefined,
 * spied on, or have its methods reassigned, and triggering a real navigation logs
 * a "Not implemented: navigation" error that fails the test run. Routing every
 * `window.location` access through this module lets tests `jest.mock` it instead —
 * `jest.mocked(assign)` for navigation assertions, `jest.mocked(getOrigin)
 * .mockReturnValue(...)` to control reads. Mirrors the `windowLocationAssign`
 * helper used across the other 3MP portals, generalized to cover reads too.
 */

// --- navigation (writes) ---

export const assign = (
  ...args: Parameters<typeof window.location.assign>
): void => window.location.assign(...args)

export const replace = (
  ...args: Parameters<typeof window.location.replace>
): void => window.location.replace(...args)

export const reload = (): void => window.location.reload()

export const setHref = (href: string): void => {
  window.location.href = href
}

// --- reads ---

export const getHref = (): string => window.location.href

export const getOrigin = (): string => window.location.origin

export const getPathname = (): string => window.location.pathname

export const getSearch = (): string => window.location.search
